import React, { useEffect, useState } from "react";
import "./AppInstallPrompt.css";

const DISMISSED_KEY = "mayachitro-install-dismissed";

export default function AppInstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches;
    const recentlyDismissed = Number(localStorage.getItem(DISMISSED_KEY) || 0) > Date.now() - 604800000;
    if (standalone || recentlyDismissed) return undefined;

    const capturePrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
      setVisible(true);
    };

    const installed = () => {
      setVisible(false);
      setInstallEvent(null);
    };

    window.addEventListener("beforeinstallprompt", capturePrompt);
    window.addEventListener("appinstalled", installed);
    return () => {
      window.removeEventListener("beforeinstallprompt", capturePrompt);
      window.removeEventListener("appinstalled", installed);
    };
  }, []);

  const install = async () => {
    if (!installEvent) return;
    await installEvent.prompt();
    await installEvent.userChoice;
    setVisible(false);
    setInstallEvent(null);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="app-install-card" aria-label="Install MayaChitro Android app">
      <img src="/mayachitro-icon-192.png" alt="" />
      <div className="app-install-copy">
        <span>MayaChitro for Android</span>
        <strong>Keep the gallery close.</strong>
        <p>Faster access, a full-screen experience, and your account in one tap.</p>
      </div>
      <button className="app-install-primary" type="button" onClick={install}>Install</button>
      <button className="app-install-close" type="button" onClick={dismiss} aria-label="Not now">×</button>
    </aside>
  );
}
